import React, { Component } from 'react'
import Modal from 'react-bootstrap/lib/Modal'
import TimeInput from './time_input'
import DateInput from './date_input'
import * as fmt from '../util/fmt_utils'
import * as timeUtils from '../util/time_utils'

const TIME = 'TIME'
const DATE = 'DATE'

class StartEnd extends Component {

    constructor(props) {
        super(props)
        this.selectStart = this.selectStart.bind(this)
        this.showDatePicker = this.showDatePicker.bind(this)
        this.hideDatePickers = this.hideDatePickers.bind(this)
        this.handleTimeFocus = this.handleTimeFocus.bind(this)
        this.renderStart = this.renderStart.bind(this)
    }

    selectStart() {
        this.startTime.select()
    }

    showDatePicker(name) {
        return () => this[name].showDatePicker()
    }

    hideDatePickers() {
        this.startDate.hideDatePicker()
        this.endDate.hideDatePicker()
    }

    handleTimeFocus(inputName) {
        this.hideDatePickers()
        this[inputName].select()
    }

    dateTimeUpdater(parentTime, updater) {
        return (dateSection, startAt, hasDefault) => value => {
            if (!value) return updater(null)

            const date = dateSection === DATE ? value : parentTime
            const time = dateSection === DATE ? parentTime : value

            const mergedDate = timeUtils.mergeDateTimes(date, time)

            // if user is saying a time before now on same date,
            // assume they mean the next day, and increment date
            if (timeUtils.isSameDay(mergedDate, startAt) && mergedDate < startAt && !hasDefault) {
                const nextDay = timeUtils.advanceOneDay(mergedDate)
                return updater(nextDay)
            }

            return updater(mergedDate)
        }
    }

    renderTimeInput({name, value, onFocus, genOnChange, hasDefaultTime}) {
        return (
            <div className="start-end-input-container">
                <i className="fa fa-clock-o start-end-icon start-end-clock" aria-hidden="true"></i>
                <TimeInput
                    placeholder=""
                    ref={(input) => { this[name] = input }}
                    value={fmt.shortTime(value)}
                    className="start-end-input time"
                    onFocus={onFocus}
                    onChange={genOnChange(TIME, this.props.startAt, hasDefaultTime)}
                    hasDefaultTime={hasDefaultTime}
                    startAt={this.props.startAt}
                    endAt={this.props.endAt}
                />
            </div>
        )
    }

    renderDateInput({name, value, genOnChange, hasDefaultDate, calendarClassName, isMobile}) {
        return (
            <div className="start-end-input-container">
                <i
                    className="fa fa-calendar start-end-icon start-end-calender"
                    aria-hidden="true"
                    onClick={this.showDatePicker(name)}
                ></i>
                <DateInput
                    placeholder=""
                    ref={(input) => { this[name] = input }}
                    value={isMobile ? fmt.numDateShortYear(value) : fmt.numDateShort(value)}
                    className="start-end-input date"
                    onChange={genOnChange(DATE, this.props.startAt, hasDefaultDate)}
                    hasDefaultDate={hasDefaultDate}
                    startAt={this.props.startAt}
                    calendarClassName={calendarClassName}
                    isMobile={isMobile}
                />
            </div>
        )
    }

    renderStart() {
        const { isStartTimer, isMobile, startAt, showTime=true, onNewTimeEntry, onStartChange } = this.props
        const startAtUpdater = this.dateTimeUpdater(startAt, onStartChange)

        const startNow = (
            <div className="start-container">
                <p className="start-end-start">Starting</p>     
                <span className='starting-now'>Now</span>
                <span className='change-start-time' onClick={() => onNewTimeEntry()}>Change</span>
            </div>
        )
        const start = (
            <div className="start-container">
                <p className="start-end-start">Start</p>
                {showTime && this.renderTimeInput({
                    name: "startTime",
                    value: startAt,
                    onFocus: () => this.handleTimeFocus("startTime"),
                    genOnChange: startAtUpdater,
                    hasDefaultTime: true,
                })}
                {this.renderDateInput({
                    name: "startDate",
                    value: startAt,
                    genOnChange: startAtUpdater,
                    hasDefaultDate: true,
                    calendarClassName: "calendar-start-date",
                    isMobile,
                })}
            </div>
        )

        return isStartTimer && isMobile
            ? startNow
            : start
    }

    render() {
        const { show, showTime=true, startAt, endAt, isMobile, isStartTimer,  editMode, stopNow } = this.props
        const style = {display: show ? 'block' : 'none'}
        const endAtUpdater = this.dateTimeUpdater(endAt || startAt, this.props.onEndChange)
        const showEndAsDisabled = isStartTimer && isMobile
        const showEndAsStop = editMode && isMobile && (endAt === 0)
        const endClass = showEndAsDisabled
            ? 'end-disabled'
            : showEndAsStop ? 'end-stop' : ''
        
        return (
            <Modal.Body className="start-end-fields" style={style}>
                <div className="start-end-container">
                    {this.renderStart()}
                    <div className={`end-container ${endClass}`} onClick ={() => {if(showEndAsStop){stopNow()}}}>
                        <p className={"start-end-end"}>End</p>
                        {showTime && this.renderTimeInput({
                            name: "endTime", 
                            value: endAt, 
                            onFocus: () => this.handleTimeFocus("endTime"), 
                            genOnChange: endAtUpdater,
                        })}
                        {this.renderDateInput({
                            name: "endDate",
                            value: endAt,
                            genOnChange: endAtUpdater,
                            calendarClassName: "calendar-end-date",
                            isMobile: isMobile,
                        })}
                    </div>
                </div>
            </Modal.Body>
        )
    }
}

export default StartEnd



// WEBPACK FOOTER //
// ./src/components/start_end.jsx